import { sectorContextGroupsFor, dependsOnSatisfied } from '../dataHelpers/sectorContextQuestions'

// Telt hoeveel sector-contextvragen een organisatie heeft beantwoord.
//
// Alleen ZICHTBARE vragen tellen mee: een vervolgvraag die pas verschijnt bij
// een bepaald antwoord (bijvoorbeeld 'worden maatregelen aangebracht of
// aangeleverd?' na 'ja') hoort niet in het totaal zolang hij niet gesteld
// wordt — anders lijkt een volledig ingevulde organisatie onvolledig.
//
// Geeft `null` voor een sector zonder contextvragen. Dat is iets anders dan
// 0 van 0: er valt niets te tonen, en de kolom hoort dan een streepje te
// laten zien in plaats van een score.
//
// @param {Record<string, Record<string, string>>} [sectorContext] - CompagnyMeta.SectorContext, genest per sector-slug
// @param {string} [sector] - sector-slug, bijvoorbeeld 'energiearmoede'
// @returns {{answered: number, total: number} | null}
const countSectorContextAnswers = (sectorContext, sector) => {

    const blocks = sectorContextGroupsFor(sector ? [sector] : [])
    if (blocks.length === 0) return null

    const answers = (sectorContext && sectorContext[sector]) || {}

    let answered = 0
    let total = 0

    blocks.forEach((block) => {
        block.groups.forEach((group) => {
            group.questions.forEach((question) => {
                if (!dependsOnSatisfied(question, answers)) return
                total++
                const value = answers[question.id]
                if (typeof value === 'string' && value.trim() !== '') answered++
            })
        })
    })

    return { answered, total }
}

export default countSectorContextAnswers
